import React, { useEffect, useRef } from "react";
import Loader from "../loader";
import TosIcon from "asset/icons/TOS.svg";

export default function PartnerTosModal({
    isOpen,
    onClose,
    onContinue,
    title = "Review our partner’s terms of service",
    loading = false,
    className = "",
}) {
    const primaryBtnRef = useRef(null);

    // Close on ESC
    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e) => e.key === "Escape" && onClose?.();
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [isOpen, onClose]);

    // Focus primary action
    useEffect(() => {
        if (isOpen) primaryBtnRef.current?.focus();
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[110] grid place-items-center bg-black/60 px-4"
            aria-labelledby="partner-tos-title"
            role="dialog"
            aria-modal="true"
            onMouseDown={(e) => {
                if (e.target === e.currentTarget) onClose?.();
            }}
        >
            <div
                className={
                    "w-full max-w-[680px] overflow-hidden rounded-[24px] bg-white shadow-xl border border-[#EEF0F5] " +
                    (className || "")
                }
            >
                {/* Header */}
                <div className="px-6 sm:px-12 pt-8 sm:pt-10 pb-8 text-center">
                    <img
                        src={TosIcon}
                        alt=""
                        aria-hidden="true"
                        className="mx-auto mb-6 h-20 w-20"
                    />

                    <h2 id="partner-tos-title" className="aku-heading-h2-semibold text-[#202939]">
                        {title}
                    </h2>

                    <p className="mt-4 aku-body-normal-regular text-[#45556C] max-w-[580px] mx-auto">
                        You’ll be redirected to read and accept the terms of service of our USD
                        wallet provider.
                    </p>
                </div>

                <div className="h-px bg-[#EEF0F5]" />

                {/* Footer */}
                <div className="flex items-center justify-end gap-6 px-6 sm:px-10 !py-6">
                    <button
                        type="button"
                        onClick={onClose}
                        className="aku-body-normal-medium text-[#494E6E] hover:opacity-80"
                    >
                        Maybe later
                    </button>

                    <button
                        type="button"
                        ref={primaryBtnRef}
                        onClick={onContinue}
                        disabled={loading}
                        className={
                            "inline-flex min-w-[136px] items-center justify-center rounded-[12px] px-7 h-12 text-white text-[17px] font-[500] " +
                            (loading
                                ? "bg-[#6F00FF]/60 cursor-not-allowed"
                                : "bg-[#6F00FF] hover:bg-[#5A00D6]")
                        }
                    >
                        {loading ? <Loader /> : "Continue"}
                    </button>
                </div>
            </div>
        </div>
    );
}
